import Button from "@app/components/button";
import GradientContainer from "@app/components/gradient/gradient-container";
import TextGradient from "@app/components/gradient/gradient-text";
import Image from "next/image";
import { useState } from "react";

const DesktopDistributionWarehouse = ({ inView4 }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="pt-72 px-24 flex flex-col xl:flex-none">
      <div className="flex justify-end ">
        <div className="hidden xl:block">
          <Image
            src="/images/industries/distributions.png"
            alt="distributions"
            className="rounded-3xl"
            width={760}
            height={512}
          />
        </div>
        <div className="xl:hidden">
          <Image
            src="/images/industries/distributions.png"
            alt="distributions"
            className="rounded-3xl"
            width={660}
            height={442}
          />
        </div>
      </div>
      <div
        className={`shadow-lg-light absolute bg-opacity-80 -mt-56 -ml-12 xl:ml-10 bg-light 
    w-[45%] 2xl:w-[55%] blur-content rounded-2xl p-6`}
        style={{
          visibility: inView4 ? 'visible' : 'hidden',
          transform: inView4 ? 'translateX(0%)' : 'translateX(-10%)',
          transition: 'transform 500ms ease-in',
          // opacity: inView2 ? 0.9 : 0,
        }}
      >
        <div
          className={`flex flex-col ml-2 space-y-5 
          ${isExpanded ? 'h-[560px] xl:h-[540px] xl-2:!h-[490px] 2xl:!h-[420px]' : 'h-[420px] xl:h-[420px] xl-2:!h-[390px] 2xl:!h-[320px] '}
           transition-[height] ease-out duration-500`}
        >
          <TextGradient>
            <p className="h2">04</p>
          </TextGradient>
          <p className="h4 xl:h3 text-background-primary-dark">Distribution Centers & Warehouses</p>
          <div>
            <GradientContainer overrideClassName="w-[40%] h-2" />
          </div>
          <div className=" text-text-color-mid-em-light space-y-5">
            <p>
              Capitalize on savings and efficiency through our Sole Source Management program.
              A combination of technology, purchasing, and operations support provides your management
              teams with the tools necessary for streamlined service delivery
              with 100% transparency.
            </p>
            {isExpanded && (
              <div>
                <p>
                  Waste profile management and equipment optimization are integral for the
                  collection and handling of the unique waste and recycling byproducts
                  generated from DC and Warehouse facilities.
                </p>
              </div>
            )}
          </div>
          <div className="flex h-full items-end">
            <div>
              <Button onClick={() => setIsExpanded(!isExpanded)}>
                {isExpanded ? 'Read less' : 'Read more'}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
};

export default DesktopDistributionWarehouse;
